export { default as AnimatedVideo } from './AnimatedVideo';
